import useAgentData from '~/client/hooks/useAgentData';
import GameBannerView from './GameBannerView';
import useGameBanner from './useGameBanner';

const TournamentGameBanner: LazyFC = () => {
  const { tournament } = useGameBanner();
  const { isDesktop } = useAgentData();

  if (!isDesktop || !tournament) {
    return null;
  }

  return <GameBannerView tournament={tournament} />;
};

export default TournamentGameBanner;
